import { Star } from 'lucide-react';
import { formatDate } from '../../lib/utils';

export const ReviewCard = ({ review }) => {
  return (
    <div className="py-6 border-b border-[#E0DFDD] last:border-0" data-testid={`review-${review.review_id}`}>
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="font-medium text-[#1A1514]">{review.user_name}</p>
          <p className="text-xs text-[#6B6A68]">{formatDate(review.created_at)}</p>
        </div>
        <div className="star-rating">
          {[...Array(5)].map((_, i) => (
            <Star 
              key={i} 
              size={14} 
              className={i < review.rating ? 'star-filled fill-current' : 'star-empty'} 
            />
          ))}
        </div>
      </div>
      <p className="text-sm text-[#6B6A68] leading-relaxed">{review.comment}</p>
    </div>
  );
};
